module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }